import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TAX_ADMIN_ROLES = ["tenant_admin", "finance_manager", "financial_controller", "chief_finance_officer"];
const LABELS = { vat_registered: "VAT registered yes or no", prices_include_tax: "whether prices include tax", tin_number: "your TIN" };

/** Shown to finance admins until VAT registration, price basis and TIN are set. */
export default function TaxSetupBanner() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const allowed = Boolean(user?.tenant_id) && TAX_ADMIN_ROLES.includes(user?.role);

  useEffect(() => {
    if (!allowed) return undefined;
    let alive = true;
    const load = () => api.get("/settings/tax/status").then((r) => { if (alive) setStatus(r.data); }).catch(() => {});
    load();
    window.addEventListener("egs-tax-settings-saved", load);
    return () => { alive = false; window.removeEventListener("egs-tax-settings-saved", load); };
  }, [allowed]);

  if (!allowed || !status || status.complete) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm" data-testid="tax-setup-banner">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <span>Tax setup is incomplete. Please set {status.missing.map((m) => LABELS[m] || m).join(", ")}.</span>
      <Link to="/reports/controls" className="font-medium underline">Open tax settings</Link>
    </div>
  );
}
